import { INavLayout } from './navModel';

/**
 * The order of the main menu. The only place where the order is decided: to move an item, move its
 * id to another position or another group; to reorder groups, move a whole line; to nest items
 * under an entry, write `{ id, children }` in its place. Nothing else changes, because an item's
 * icon, route, label and visibility rule live in navItems.ts and travel with it.
 *
 * `body` scrolls; `footer` is pinned to the bottom of the rail. A group whose items are all
 * invisible for the current user is dropped, caption and all. The user can close a group by its
 * caption unless it says `isCollapsible: false`.
 *
 * The pinned groups also order the pivot rows of Administration and Tenant Admin (navLayoutOrder.ts), so
 * a page and its menu entry always sit at the same position. Their order is for people: the work of every
 * week first, the periodic governance in the middle, the setup that is done once and the technical
 * configuration last (docs/phase-26-admin-ux-fixes.md, D26-2).
 */
export const navLayout: INavLayout = {
  body: [
    {
      // The entry group, where everyone begins. No caption: a caption over the only group says nothing
      // (phase 30, D30-11), and a group without one never closes.
      items: ['start', 'skills', 'history', 'approvals'],
    },
  ],
  footer: [
    {
      header: 'admin',
      items: [
        // the work of every week: people, the Capabilities Skills run on, what to install or publish
        'admin-users',
        'admin-capabilities',
        'admin-library',
        'admin-marketplace',
        'admin-publishing',
        // governance, reviewed from time to time: who may do what, the record, the groups behind both
        'admin-policies',
        'admin-audit',
        'admin-groups',
        // set up once, technical
        'admin-integrations',
        'admin-models',
        'admin-backup',
        'admin-subscription',
        'admin-a2a',
      ],
    },
    {
      header: 'tenantadmin',
      items: [
        'tenantadmin-manage',
        'tenantadmin-marketplace',
        'tenantadmin-capability-catalog',
        'tenantadmin-subscription-types',
        'tenantadmin-ai-credits',
        'tenantadmin-identity-issuers',
      ],
    },
  ],
};
